module.exports = __webpack_public_path__ + "img/4.ee6cb06d.png";